import { Check } from "lucide-react";

const STEPS = ["Desire", "Blocker", "Root cause", "Rewrite"];

export const parseStep = (messages) =>
  messages.reduce((acc, m) => {
    if (m.role !== "assistant") return acc;
    const all = [...(m.content || "").matchAll(/\[\[STEP:(\d)\]\]/g)];
    const n = all.length ? Number(all[all.length - 1][1]) : 0;
    return Math.max(acc, n);
  }, 0);

export const ManifestTracker = ({ step, complete }) => (
  <div className="shrink-0 border-b border-[rgba(140,79,214,0.18)] px-5 py-3 cg-glass" data-testid="manifest-tracker">
    <ol className="max-w-2xl mx-auto flex items-center gap-2">
      {STEPS.map((label, i) => {
        const n = i + 1;
        const done = complete || n < step;
        const current = !complete && n === Math.max(step, 1);
        return (
          <li key={label} className="flex-1 flex items-center gap-2 min-w-0" data-testid={`manifest-step-${n}`}
            data-state={done ? "done" : current ? "current" : "upcoming"}>
            <span className={`h-6 w-6 shrink-0 rounded-full grid place-items-center text-[10px] font-mono transition-colors duration-500 ${
              done ? "bg-cg-cyan text-cg-deep" : current ? "border border-cg-cyan text-cg-cyan shadow-[0_0_12px_rgba(92,200,240,0.5)]" : "border border-[rgba(140,79,214,0.35)] text-cg-textm"}`}>
              {done ? <Check className="h-3 w-3" /> : n}
            </span>
            <span className={`${current ? "" : "hidden sm:inline"} truncate text-[11px] font-mono uppercase tracking-widest ${current ? "text-cg-textp" : done ? "text-cg-cyan" : "text-cg-textm"}`}>
              {label}
            </span>
            {n < 4 && <span className={`hidden sm:block flex-1 h-px ${done ? "bg-cg-cyan/60" : "bg-[rgba(140,79,214,0.25)]"}`} />}
          </li>
        );
      })}
    </ol>
  </div>
);
